import { BehaviorSubject } from 'rxjs';

// Shared because the sign-in redirect is triggered from two places (route guard and the 401 handler),
// while only the route guard can render a recovery screen.
const signInUnavailableSubject = new BehaviorSubject<boolean>(false);

export const getSignInUnavailableSubject = (): BehaviorSubject<boolean> => signInUnavailableSubject;

export const setSignInUnavailable = (unavailable: boolean): void => signInUnavailableSubject.next(unavailable);
